"use client";

import { Checkbox } from "@/components/ui/checkbox";
import {
  setUmrahFilters,
  useUmrahFilter,
} from "@/feature/umrah/package/search/state/extract-umrah-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { UmrahAccordion } from "./umrah-accordion";

function getDurationLabel(value: string) {
  if (value === "1-7") return "1-7 Days";
  if (value === "8-14") return "8-14 Days";
  return "15+ Days";
}

export function UmrahDurationFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption, defaultOption } = useAppSelector(useUmrahFilter);
  const options = defaultOption.durations;

  if (!options.length) {
    return null;
  }

  return (
    <UmrahAccordion value="duration" label="Duration">
      <div className="space-y-2">
        {options.map((duration) => (
          <label
            key={duration}
            className="flex items-center gap-2 text-sm text-muted-foreground"
          >
            <Checkbox
              checked={selectedOption.durations.includes(duration)}
              onCheckedChange={(checked) => {
                if (checked === "indeterminate") return;

                const next = selectedOption.durations.includes(duration)
                  ? selectedOption.durations.filter((item) => item !== duration)
                  : [...selectedOption.durations, duration];
                dispatch(setUmrahFilters({ durations: next }));
              }}
            />
            <span>{getDurationLabel(duration)}</span>
          </label>
        ))}
      </div>
    </UmrahAccordion>
  );
}
